const tokens = {
  access_token: 'access_token',
  refresh_token: 'refresh_token'
};

export const clearTokens = () => {
    localStorage.removeItem(tokens.access_token);
    localStorage.removeItem(tokens.refresh_token);
}

export const getAccessToken = () => {
    return localStorage.getItem(tokens.access_token);
}

export const getRefreshToken = () => {
    return localStorage.getItem(tokens.refresh_token);
}

export const setAccessToken = (jwt) => {
    localStorage.setItem(tokens.access_token, jwt);
}

export const setRefreshToken = (jwt) => {
    localStorage.setItem(tokens.refresh_token, jwt);
}

export const setReminderForLoggedUser = (user_uuid, reminder) => {
    localStorage.setItem(user_uuid, JSON.stringify({ reminder }));
}

export const getReminderForLoggedUser = (user_uuid) => {
    if (localStorage.getItem(user_uuid)) {
        const { reminder } = JSON.parse(localStorage.getItem(user_uuid));
        return reminder;
    }
    return '';
}
